module.exports = __webpack_public_path__ + "img/certificate-CU-outstanding.facfb766.jpg";